import { Component } from '@theme/component';

class NaptonFleetComparison extends Component {
  #controller;
  #opener;

  connectedCallback() {
    super.connectedCallback();
    this.#bind();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#bind();
  }

  disconnectedCallback() {
    this.#controller?.abort();
    for (const dialog of this.querySelectorAll('dialog[open]')) dialog.close();
    super.disconnectedCallback();
  }

  #bind() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.addEventListener('click', this.#click, { signal });
    for (const button of this.querySelectorAll('[data-open-fleet]')) button.hidden = false;
    for (const dialog of this.querySelectorAll('dialog')) {
      dialog.addEventListener('close', () => {
        if (this.#opener?.isConnected) this.#opener.focus({ preventScroll: true });
        this.#opener = undefined;
      }, { signal });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right ||
            event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      }, { signal });
    }
  }

  #click = event => {
    if (!(event.target instanceof Element)) return;
    const open = event.target.closest('[data-open-fleet]');
    if (open) {
      const dialog = this.querySelector(`[data-fleet-dialog="${open.dataset.openFleet}"]`);
      if (!(dialog instanceof HTMLDialogElement)) return;
      this.#opener = open;
      dialog.showModal();
      return;
    }
    const close = event.target.closest('[data-close-fleet]');
    if (close) {
      close.closest('dialog')?.close();
      return;
    }
    const photo = event.target.closest('[data-fleet-photo]');
    if (photo) {
      const dialog = photo.closest('dialog');
      if (!dialog) return;
      for (const button of dialog.querySelectorAll('[data-fleet-photo]')) {
        button.setAttribute('aria-pressed', String(button === photo));
      }
      for (const panel of dialog.querySelectorAll('[data-fleet-shot]')) {
        panel.hidden = panel.dataset.fleetShot !== photo.dataset.fleetPhoto;
      }
      const status = dialog.querySelector('[data-fleet-caption]');
      if (status) status.textContent = photo.dataset.caption;
      return;
    }
    if (event.target.closest('[data-fleet-book]')) event.target.closest('dialog')?.close();
  };
}

if (!customElements.get('napton-fleet-comparison')) {
  customElements.define('napton-fleet-comparison', NaptonFleetComparison);
}
